import axios from "axios";
import { BASE_URL } from "./api";


// axios.interceptors.response.use(function (response) {
//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     return response;
//   }, function (error) {
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error
//     console.log('error found in interceptors')
//     return Promise.reject(error);
//   });

export async function getPageConfigs (token, filters) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/company_page_configurations/?${filters}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error
    });
}

export async function createPageConfig (token, data) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/company_page_configurations/create_page_config/`,
        headers: {
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response;
    }).catch((error) => {
        alert(error)
    });
}

export async function updatePageConfig (token, data, configId) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/company_page_configurations/${configId}/update_page_config/`,
        headers: {
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response;
    }).catch((error) => {
        alert(error)
    });
}

export async function deletePageConfig(token, configId) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/company_page_configurations/${configId}/delete_config/`,
        headers: {
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        return response;
    }).catch((error) => {
        alert(error)
    });
}

export async function getPageConfig (token, pageConfigId) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/company_page_configurations/${pageConfigId}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error
    });
}

export async function getPinnedUserCompanyFilterFields(token, userId) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/user-company-filters?pinned=true&user=${userId}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response;
    }).catch((error) => {
        throw error
    });
}

export async function getUserCompanyFilterFields(token, userId) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/user-company-filters?user=${userId}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response;
    }).catch((error) => {
        throw error
    });
}

export async function createPinnedUserCompanyFilterField(token, payload) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/user-company-filters/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: payload
    }).then((response) => {
        return response;
    }).catch((error) => {
        throw error
    });
}

export async function setPinnedUserCompanyFilterField(token, payload) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/user-company-filters/set_pinned/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: payload
    }).then((response) => {
        return response;
    }).catch((error) => {
        throw error
    });
}

export async function setDefaultUserCompanyFilterFields(token, data) {
    return axios({
        method: 'put',
        url: `${BASE_URL}/user-company-filters/set_defaults/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response;
    }).catch((error) => {
        throw error
    });
}

export async function deletePinnedUserCompanyFilterField(token, userCompanyFilterFieldId) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/user-company-filters/${userCompanyFilterFieldId}/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
    }).then((response) => {
        return response;
    }).catch((error) => {
        throw error
    });
}

export async function getPinnedUserCompanyBulkOperationFields(token, userId) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/user-company-bulk-operations?pinned=true&user=${userId}`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response;
    }).catch((error) => {
        throw error
    });
}

export async function createPinnedUserCompanyBulkOperationField(token, payload) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/user-company-bulk-operations/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: payload
    }).then((response) => {
        return response;
    }).catch((error) => {
        throw error
    });
}

export async function deletePinnedUserCompanyBulkOperationField(token, userCompanyBulkOperationFieldId) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/user-company-bulk-operations/${userCompanyBulkOperationFieldId}/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
    }).then((response) => {
        return response;
    }).catch((error) => {
        throw error
    });
}

export async function updateFilterOrdinals(token, filterIdOrdinalPairs) {
  return axios({
    method: 'put',
    url: `${BASE_URL}/user-company-filters/reorder/`,
    headers: {
        'Authorization': `Token ${token}`
    },
    data: filterIdOrdinalPairs
    }).then((response) => {
        return response;
    }).catch((error) => {
        console.log(error)
        return error
    });
}

export async function updateBulkOperationOrdinals(token, bulkOperationIdOrdinalPairs) {
  return axios({
    method: 'put',
    url: `${BASE_URL}/user-company-bulk-operations/reorder/`,
    headers: {
        'Authorization': `Token ${token}`
    },
    data: bulkOperationIdOrdinalPairs
    }).then((response) => {
        return response;
    }).catch((error) => {
        console.log(error)
        return error
    });
}
